module.exports = __webpack_public_path__ + "img/features_3.1f65907f.png";